module.exports = "/assets/data/6edce13ebbbb9ed0db094ed0b858d6be-TR25.data.json";